const Reflux = require('@muzzylane/reflux');

const _ = {
    get: require('lodash/get'),
    includes: require('lodash/includes'),
    isArray: require('lodash/isArray'),
    isEmpty: require('lodash/isEmpty'),
    uniq: require('lodash/uniq'),
};

const Globals = require('../../../app/globals');

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const GlobalUserActions = Reflux.createActions({
    getInfo: { children: ['completed', 'failed'] },
    getInfos: { children: ['completed', 'failed'] },
    getAvailable: { children: ['completed', 'failed'] },
    getAuthors: { children: ['completed', 'failed'] },
    getOrgs: { children: ['completed', 'failed'] },
    getLTIUsers: { children: ['completed', 'failed'] },
    getLaunchCounts: { children: ['completed', 'failed'] },
    getChannelRoles: { children: ['completed', 'failed'] },
    getComments: { children: ['completed', 'failed'] },
    getAdminStudentFeedback: { children: ['completed', 'failed'] },
    updateAdminStudentFeedback: { children: ['completed', 'failed'] },
    getStudentFeedbackCategories: { children: ['completed', 'failed'] },
    getOverviewStats: { children: ['completed', 'failed'] },
    getLmsDeployments: { children: ['completed', 'failed'] },
    deleteUser: { children: ['completed', 'failed'] },
    resendRegistrationVerification: { children: ['completed', 'failed'] },
    adminUpdateUser: { children: ['completed', 'failed'] },
    getActionHistory: { children: ['completed', 'failed'] },
});

GlobalUserActions.getInfo.listen(function(actionId, params) {
    if (!params.id) {
        this.failed(actionId, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/users/${params.id}`, 'GET')
        .then(res => this.completed(actionId, params.id, res))
        .catch(err => this.failed(actionId, params.id, err));
});

GlobalUserActions.getInfos.listen(function(actionId, params) {
    if (
        !params.ids
        || !_.isArray(params.ids)
        || params.ids.length === 0
    ) {
        this.failed(actionId, params.ids, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const uniqueIds = _.uniq(params.ids);
    ServerRequest.makeRequest('/authoring/users', 'POST', JSON.stringify({
            ids: uniqueIds,
        }))
        .then(res => this.completed(actionId, uniqueIds, res))
        .catch(err => this.failed(actionId, uniqueIds, err));
});

GlobalUserActions.getAvailable.listen(function(actionId, params) {
    const self = this;

    if (!params.email) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest('/authoring/users/available', 'POST', JSON.stringify(params))
        .then(function(res) {self.completed(actionId, params.email, res)})
        .catch(function(err) {self.failed(actionId, params.email, err)});
});

GlobalUserActions.getAuthors.listen(function(actionId, params) {
    const userPage = _.get(params, 'userPage', '1');
    const userSearch = _.get(params, 'userSearch', '');
    const userSort = _.get(params, 'userSort', '');
    const userSortOrder = _.get(params, 'userSortOrder', '');
    ServerRequest.makeRequest(`/authoring/users?q=all&t=author&page=${userPage}&search=${userSearch}&sort=${userSort}&order=${userSortOrder}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

GlobalUserActions.getOrgs.listen(function(actionId, params) {
    const userPage = _.get(params, 'userPage', '1');
    const userSearch = _.get(params, 'userSearch', '');
    const userSort = _.get(params, 'userSort', '');
    const userSortOrder = _.get(params, 'userSortOrder', '');
    ServerRequest.makeRequest(`/authoring/users?q=all&t=org&page=${userPage}&search=${userSearch}&sort=${userSort}&order=${userSortOrder}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

GlobalUserActions.getLTIUsers.listen(function(actionId, params) {
    const userPage = _.get(params, 'userPage', '1');
    const userSearch = _.get(params, 'userSearch', '');
    const userSort = _.get(params, 'userSort', '');
    const userSortOrder = _.get(params, 'userSortOrder', '');
    ServerRequest.makeRequest(`/authoring/users?q=all&t=lti&page=${userPage}&search=${userSearch}&sort=${userSort}&order=${userSortOrder}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

GlobalUserActions.getLaunchCounts.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/overview_activity_launches', 'POST', JSON.stringify({ user_id: params.userId }))
        .then(res => this.completed(actionId, params.userId, res))
        .catch(err => this.failed(actionId, params.userId, err));
});

GlobalUserActions.getChannelRoles.listen(function(actionId, user_id) {
    const self = this;
    ServerRequest.makeRequest('/authoring/user/' + user_id + '/channel_roles', 'GET')
        .then(function(res) { self.completed(actionId, user_id, res) })
        .catch(function(err) { self.failed(actionId, user_id, err) });
});

GlobalUserActions.getComments.listen(function(actionId, user_id) {
    const self = this;
    ServerRequest.makeRequest('/authoring/user/' + user_id + '/comments', 'GET')
        .then(function(res) { self.completed(actionId, res) })
        .catch(function(err) { self.failed(actionId, err) });
});

GlobalUserActions.getAdminStudentFeedback.listen(function(actionId, params) {
    const self = this;
    
    const page = _.get(params, 'page', '1');
    const commentSearchTerm = _.get(params, 'commentSearchTerm','');
    const categorySearchTerm = _.get(params, 'categorySearchTerm',null);
    const sortBy = _.get(params, 'sortBy', '');
    const sortOrder = _.get(params, 'sortOrder', '');
    let data = {
        page,
        commentSearchTerm,
        categorySearchTerm,
        sortBy,
        sortOrder
    };
    
    ServerRequest.makeRequest('/authoring/admin/feedback_comments', 'POST',JSON.stringify(data))
        .then(function(res) { self.completed(actionId, res) })
        .catch(function(err) { self.failed(actionId, err) });
});

GlobalUserActions.updateAdminStudentFeedback.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest('/authoring/admin/update_feedback_comment', 'POST',JSON.stringify(params))
        .then(function(res) { self.completed(actionId, res) })
        .catch(function(err) { self.failed(actionId, err) });
});

GlobalUserActions.getStudentFeedbackCategories.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/feedback_comment_categories', 'GET')
        .then((res)=>{ this.completed(actionId, res) })
        .catch((err)=>{ this.failed(actionId, err) });
});

GlobalUserActions.getOverviewStats.listen(function(actionId, manager) {
    const self = this;
    ServerRequest.makePollTaskRequest('/authoring/overview_stats', 'POST',"",manager,actionId)
        .then(res => self.completed(actionId, res))
        .catch(err => self.failed(actionId, err));
});

GlobalUserActions.getLmsDeployments.listen(function(actionId,userId) {
    const self = this;
    ServerRequest.makeRequest('/authoring/user/' + userId + '/lms_deployments', 'GET')
        .then(function(res) { self.completed(actionId, userId, res) })
        .catch(function(err) { self.failed(actionId, userId, err) });
});

GlobalUserActions.deleteUser.listen(function(actionId, userId) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/users/${userId}`, 'DELETE')
        .then(res => self.completed(actionId, userId, res))
        .catch(err => self.failed(actionId, err));
});

GlobalUserActions.resendRegistrationVerification.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/user/${params.userId}/register/resend`, 'POST')
        .then(res => self.completed(actionId, params.userId, res))
        .catch(err => self.failed(actionId, params.userId, err));
});

GlobalUserActions.adminUpdateUser.listen(function(actionId, params) {
    const reqParams = {};

    if (params.local_role_type) {
        reqParams.local_role_type = params.local_role_type;
    }
    
    if (params.account_type) {
        reqParams.account_type = params.account_type;
    }

    if (Object.keys(reqParams) === 0) {
        this.failed(actionId, params.userId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/user/${params.userId}/update/admin`, 'PUT', JSON.stringify(reqParams))
        .then(res => this.completed(actionId, params.userId, res))
        .catch(err => this.failed(actionId, params.userId, err));
});


GlobalUserActions.getActionHistory.listen(function(actionId, params) {
    let { userId, dayRange, ...theRest } = params;
    if (!_.isEmpty(theRest)) {
        console.log("WARNING: getActionHistory ignoring params: ",JSON.stringify(theRest));
    }
    
    if (!_.includes(Globals.user_actions.day_ranges,dayRange)) {
        this.failed(actionId, params, new ForgeError({ message: "invalid day range" }));
        return;
    }
    const self = this;
    ServerRequest.makeRequest(`/authoring/users/${userId}/action_history?range=${dayRange}`, 'GET')
        .then(res => self.completed(actionId, params, res))
        .catch(err => self.failed(actionId, params, err));
});

module.exports = GlobalUserActions;